import React from "react";
import PropTypes from "prop-types";

const Card = ({ children, className }) => {
  return <div className={`rounded-lg shadow mb-6 p-5 bg-white ${className}`}>{children}</div>;
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Card.defaultProps = {
  className: "",
};

export default Card;
